import { render } from "./BancoList.vue?vue&type=template&id=5fa3ae58&scoped=true"
import script from "./BancoList.vue?vue&type=script&lang=js"
export * from "./BancoList.vue?vue&type=script&lang=js"

import "./BancoList.vue?vue&type=style&index=0&id=5fa3ae58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa3ae58"]])

export default __exports__